import React, { useRef, useEffect } from 'react';

const LineOverlay = ({ targetElementId,show,percent }) => {
  const lineRef = useRef(null);

  useEffect(() => {
    const targetElement = document.getElementById(targetElementId);
    if (!targetElement) {
      console.log(targetElementId + ' not found');
      return;
    }

    const rect = targetElement.getBoundingClientRect();
    const borderBottomHeight = targetElement.offsetHeight - targetElement.clientHeight;
    const borderBottomPosition = rect.top + rect.height - borderBottomHeight;

    if (lineRef.current) {
      lineRef.current.style.position = 'absolute';
      lineRef.current.style.left = `${rect.left}px`;
      lineRef.current.style.top = `${borderBottomPosition}px`;
      lineRef.current.style.width = `${rect.width * percent}px`;
      lineRef.current.style.height = `1px`;
      lineRef.current.style.background = '#FF8A00'; 
    }

  }, [targetElementId,percent]);

  if(!show)
    return <div ref={lineRef}></div>

  return <div id='lineoverlay' ref={lineRef} />;
};

export default LineOverlay;